import React from 'react'

import { Alert, AlertProps, Button, ButtonProps } from '@mantine/core'

import { FaIcon } from '#components/FaIcon'

import styles from './Alerts.module.css'

type WarningAlertProps = Omit<AlertProps, 'color' | 'icon' | 'styles'> & {
  color?: 'yellow' | 'orange'
}

export function WarningAlert({
  color = 'yellow',
  ...props
}: WarningAlertProps) {
  const icon = <FaIcon icon="fa-exclamation-triangle" />

  if (color === 'orange') {
    return (
      <Alert
        {...props}
        icon={icon}
        classNames={{
          root: styles.orange,
          icon: styles.orangeIcon,
          title: styles.orangeText,
          message: styles.orangeText,
        }}
      />
    )
  }

  return (
    <Alert
      {...props}
      color="yellow"
      icon={icon}
      styles={{ title: { color: 'var(--mantine-color-text)' } }}
    />
  )
}

export function ErrorAlert(props: WarningAlertProps) {
  return (
    <Alert
      {...props}
      color="red"
      icon={<FaIcon icon="fa-exclamation-circle" />}
      styles={{ title: { color: 'var(--mantine-color-text)' } }}
    />
  )
}

type WarningAlertButtonProps = Omit<
  ButtonProps & React.ComponentPropsWithoutRef<'button'>,
  'color' | 'size' | 'variant'
>

function WarningAlertButton(props: WarningAlertButtonProps) {
  return (
    <Button
      {...props}
      color="yellow"
      size="xs"
      vars={() => ({
        root: {
          '--button-bg': 'var(--mantine-color-yellow-light)',
          '--button-color': 'var(--mantine-color-text)',
          '--button-hover': 'var(--mantine-color-yellow-light-hover)',
          '--button-hover-color': 'var(--mantine-color-text)',
        },
      })}
      variant="light"
    />
  )
}

WarningAlert.Button = WarningAlertButton
